<app-stages [stages]="stages" currentStage="Oświadczenia"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate [formGroup]='form' (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <legend>
        Oświadczenia
      </legend>
      @if (form.invalid && form.allIsTouched) {
        <div class="row">
          <div class="col-md-6 ">
            <app-alert type="danger" alertTitle="Uwaga!" [closable]="false">
              Zaznacz wymagane oświadczenia.
            </app-alert>
          </div>
        </div>
      } @else {
        <br>
      }
      <div class="row">
        <div class="col-12">
          <div class='form-group' *ngIf='"testimonyStatement" as controlName'>
            <div class='custom-checkbox' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                [formControlName]='controlName'
                type='checkbox'
                [id]='controlName'
                [name]='controlName'>
              <label [for]='controlName'>
                * Pouczony o odpowiedzialności za składanie fałszywych zeznań na podstawie art. 75 § 2 ustawy z dnia 14
                czerwca 1960 r. Kodeks postępowania administracyjnego oświadczam, że dane zawarte w tym wniosku są
                zgodne ze stanem faktycznym.
              </label>
            </div>
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class='col-md-5'>
          <div class='form-group' *ngIf='"propertyUsagePurpose" as controlName'>
            <label [for]='controlName'>
              Forma władania *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              <option [value]='item' *ngFor='let item of form.propertyUsagePurposeList'>
                {{ item }}
              </option>
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      @if (form.propertyUsagePurpose.value | propertyOwnerStatementContent; as content) {
        <br>
        <div class="row">
          <div class="col-12">
            <div class='form-group' *ngIf='"propertyOwnerStatement" as controlName'>
              <div class='custom-checkbox' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                <input
                  [formControlName]='controlName'
                  type='checkbox'
                  [id]='controlName'
                  [name]='controlName'>
                <label [for]='controlName'>
                  * Oświadczam, że {{ content }}
                </label>
              </div>
            </div>
          </div>
        </div>
      }
      <br>
      <div class="row">
        <div class="col-12">
          <div class="editor-content">
            <article id="electronicCorrespondenceConsentDesc">
              <p>
                * Usunięcie drzewa (drzew) lub krzewów wynika z celu związanego z prowadzeniem działalności
                gospodarczej:
              </p>
            </article>
          </div>
          <div class='form-group' *ngIf='"removalForBusinessPurpose" as controlName'>
            <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                aria-describedby="removalForBusinessPurposeDesc"
                [formControlName]="controlName"
                type="radio"
                id="removalForBusinessPurposeYes"
                [value]="true">
              <label for="removalForBusinessPurposeYes">Tak</label>
            </div>
            <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                aria-describedby="removalForBusinessPurposeDesc"
                [formControlName]="controlName"
                type="radio"
                id="removalForBusinessPurposeNo"
                [value]="false">
              <label for="removalForBusinessPurposeNo">Nie</label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
  </form>
  <div class='application-actions'>
    <button
      type='button'
      class='btn btn-secondary'
      (click)='onCancel()'>
      <span>
        Wstecz
      </span>
    </button>
    <button
      type='button'
      class='btn btn-primary'
      (click)='submitAndGoNext()'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
